class InlineQuickAdd extends HTMLDivElement {
  constructor() {
    super();

    this.parentCard = this.closest('product-recommendation-card') || this.closest('product-card');

    this.elements = {
      addToCart: this.querySelectorAll('[data-inline-quick-add-el="addToCart"]'),
      trigger: this.parentCard.querySelector('[data-inline-quick-add-el="trigger"]'),
      heading: this.parentCard.querySelector('[data-product-card-el-heading-el="heading"]'),
      cartItems: document.querySelector('cart-items'),
      close: this.querySelector('[data-inline-quick-add-el="close"]'),
    }
  }

  connectedCallback() {
    this.elements.addToCart.forEach(button => {
      button.addEventListener('click', this.handleAddToCart.bind(this));
    });

    document.addEventListener('click', (event) => {
      const isClickInside = this.contains(event.target);
      const isClickOnTrigger = event.target.closest('[data-inline-quick-add-el="trigger"]');

      if (!isClickInside && !isClickOnTrigger) {
        this.handleClose(event);
      }
    });

    window.addEventListener('inline-quick-add:open', this.handleOpen.bind(this));
    this.elements.close.addEventListener('click', this.handleClose.bind(this));
  }

  handleOpen(event) {
    const hash = event.detail.hash;

    if (hash !== this.dataset.inlineQuickAddHash) {
      return;
    }

    this.removeAttribute('hidden')
    this.elements.trigger.setAttribute('hidden', '')
    this.elements.heading.setAttribute('hidden', '')
  }

  handleClose(event) {
    this.setAttribute('hidden', '')
    this.elements.trigger.removeAttribute('hidden')
    this.elements.heading.removeAttribute('hidden')
  }

  async handleAddToCart(event) {
    const variantId = event.target.dataset.variantId;
    console.log(variantId)

    const body = {
      sections: this.elements.cartItems.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
      items: [
        {
          id: variantId,
          'quantity': 1,
        }
      ]
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })

    if (response.ok) {
      const json = await response.json()
      this.elements.cartItems.renderContents(json)
    }
  }
}

customElements.define('inline-quick-add', InlineQuickAdd, { extends: 'div' });
